import { createSelector } from '@ngrx/store';
import type { SalesYear } from '../../shared/models/sales-year.type';
import { getIdParam } from './router.selector';
import { selectSalesYearFromRoute } from './sales-years.selector';

export * from './account-finalization.selector';
export * from './flagsmith-feature-flag.selectors';
export * from './mid-tier-program.selector';
export * from './products.selectors';
export * from './router.selector';
export * from './sales-lookup.selectors';
export * from './sales-years.selector';
export * from './system-info.selector';
export * from './user.selector';

export const getIdParamAndSelectedSalesYear = createSelector(
  getIdParam,
  selectSalesYearFromRoute,
  (id: number, salesYear: SalesYear | undefined) => {
    return {
      id,
      salesYear,
    };
  }
);
